// extracted by mini-css-extract-plugin
export default {"fixed":"styles_fixed__kLigJ"};